


import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import myVideo from "@/components/myVideo";
import myAudio from "@/components/myAudio";
export default {

components: { Swiper, SwiperItem, myVideo, myAudio },
data() {

return {
id: this.$route.query.id,
poi: null,
videoHeight: 0, //视频高度
isShowVideo: false,
audioSrc: null
};
},

computed: {},

watch: {},

methods: {
getIntangiblePointsDetail(id) {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/getIntangiblePointsDetail",
params: {
id: id
},
isShowLoading: true,
success: function(data) {
console.log(data.data);
that.poi = data.data.data;
document.title = data.data.data.pointsDetail.name;
if (data.data.data.pointsDetail.audio) {
let idx = data.data.data.pointsDetail.audio.lastIndexOf(".");
that.audioSrc =
data.data.data.pointsDetail.audio.substring(0, idx + 1) + "mp3";
}

that.$nextTick(function() {
that.videoHeight = document.getElementById("banner").offsetHeight;
});
}
});
},
playVideo() {
let that = this;
this.isShowVideo = true;






},

myVideoEnded() {
this.isShowVideo = false;
}
},

created() {
this.getIntangiblePointsDetail(this.id);
},

mounted() {},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/poi.vue